import { render } from "./PWAUpdatePrompt.vue?vue&type=template&id=6ec86e8e&scoped=true"
import script from "./PWAUpdatePrompt.vue?vue&type=script&lang=js"
export * from "./PWAUpdatePrompt.vue?vue&type=script&lang=js"

import "./PWAUpdatePrompt.vue?vue&type=style&index=0&id=6ec86e8e&scoped=true&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec86e8e"],['__file',"PWAUpdatePrompt.vue"]])

export default __exports__